import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12 col-md-5 col-lg-3" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "col-sm-12 col-md-5 col-lg-3" }
const _hoisted_5 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-12 col-md-5 col-lg-4" }
const _hoisted_8 = ["id"]
const _hoisted_9 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          class: "form-control w-100",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentUser.userPK) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeUser(_ctx.currentUser.userPK)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Users, (user) => {
            return (_openBlock(), _createElementBlock("option", {
              key: user.userPK,
              value: user.userPK
            }, _toDisplayString(user.userPK), 9, _hoisted_3))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.currentUser.userPK]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePermissions())),
          class: "btn btn-primary w-100"
        }, [
          _cache[3] || (_cache[3] = _createTextVNode(" Actualizar ", -1)),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("i", _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("br", { class: "m-5" }, null, -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Profiles, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "form-check",
            key: item.profileId
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              id: item.profileId
            }, null, 8, _hoisted_8),
            _createElementVNode("label", {
              class: "form-check-label",
              for: item.profileId
            }, _toDisplayString(item.profileId), 9, _hoisted_9)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}